/*
 * Jewelry cart drawer — behaviour for sections/svj-drawer.liquid.
 * Self-contained: Shrine's own cart-drawer is hidden in svj.css, so nothing here
 * depends on Shrine's remote main.js. Cart mutations are detected by wrapping
 * fetch/XHR, and the drawer re-renders itself from /?section_id=svj-drawer.
 * Built 18-Sep-2026.
 */
(function () {
  var SECTION = 'svj-drawer';
  var busy = false;
  var userClosed = false; /* set by close(); a pending add/refresh must not re-open the drawer after it */

  function root() { return document.getElementById('svj-drawer'); }

  function open() {
    var el = root();
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('svj-drawer-open');
  }

  function close() {
    userClosed = true;
    var el = root();
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('svj-drawer-open');
    /* The header cart icon also opens Shrine's own (hidden) cart-drawer, which locks the page with
       body.overflow-hidden and never closes — the page could not scroll after our drawer closed (21-Oct-2026). */
    var shrine = document.querySelector('cart-drawer');
    if (shrine && shrine.classList.contains('active')) {
      try { if (typeof shrine.close === 'function') shrine.close(); } catch (e) { /* fall through */ }
      shrine.classList.remove('active', 'animate');
    }
    document.body.classList.remove('overflow-hidden');
  }

  /* Open straight away with a loading state so a tap on "Add to cart" gets instant feedback (13-Oct-2026). */
  function openLoading() {
    userClosed = false;
    open();
    var el = root();
    if (el) el.classList.add('is-loading');
  }

  function render(html, thenOpen) {
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var fresh = holder.querySelector('#svj-drawer');
    var current = root();
    if (fresh && current) {
      var wasOpen = current.classList.contains('is-open');
      current.replaceWith(fresh);
      if (wasOpen || (thenOpen && !userClosed)) open();
    }
    fillDeal();
    syncCount();
  }

  /* "Any 4 for $99" in the visitor's currency: the SMART discount is set in USD and converted at checkout (21-Oct-2026) */
  function fillDeal() {
    var cur = (window.Shopify && window.Shopify.currency) || {};
    var code = cur.active || 'USD';
    /* UK has its own SMART deal (VAT included): 4 x $29.71 = $118.84 → £88.80; everyone else 4 x $24.75 = $99 (26-Oct-2026) */
    var usd = window.Shopify && window.Shopify.country === 'GB' ? 118.84 : 99;
    var amount = Math.ceil(usd * (parseFloat(cur.rate) || 1));
    var text;
    try {
      text = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: code, minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount);
    } catch (e) { text = '$' + amount; }
    document.querySelectorAll('[data-deal4]').forEach(function (n) { n.textContent = text; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fillDeal); else fillDeal();

  function stopLoading() { var el = root(); if (el) el.classList.remove('is-loading'); }

  function refresh(thenOpen) {
    return nativeFetch('/?section_id=' + SECTION, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) { render(html, thenOpen); })
      .catch(stopLoading);
  }

  /* Header cart bubble: re-render it from the header section itself, so it keeps Shrine's own count rules
     (cart-hidden upsells excluded) and appears when the cart goes from empty to 1 (21-Oct-2026). */
  function syncCount() {
    var bubble = document.getElementById('cart-icon-bubble');
    var section = bubble && bubble.closest('.shopify-section');
    if (!section) return;
    nativeFetch('/?section_id=' + encodeURIComponent(section.id.replace(/^shopify-section-/, '')), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-icon-bubble');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  function change(line, qty) {
    if (busy) return;
    busy = true;
    nativeFetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function () { busy = false; return refresh(false); })
      .catch(function () { busy = false; });
  }

  function add(variantId) {
    if (busy) return;
    busy = true;
    nativeFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    })
      .then(function () { busy = false; return refresh(true); })
      .catch(function () { busy = false; });
  }

  /* ---- delegated events (drawer markup is replaced wholesale on refresh) ---- */
  document.addEventListener('click', function (e) {
    var el = root();

    if (e.target.closest('[data-svj-close]')) { e.preventDefault(); close(); return; }

    var step = e.target.closest('[data-svj-step]');
    if (step && el && el.contains(step)) {
      e.preventDefault();
      var line = parseInt(step.dataset.line, 10);
      var input = el.querySelector('.svj-qty__input[data-line="' + line + '"]');
      var next = parseInt(input.value, 10) + parseInt(step.dataset.svjStep, 10);
      change(line, next < 0 ? 0 : next);
      return;
    }

    var del = e.target.closest('[data-svj-remove]');
    if (del && el && el.contains(del)) { e.preventDefault(); change(parseInt(del.dataset.svjRemove, 10), 0); return; }

    var plus = e.target.closest('[data-svj-add]');
    if (plus && el && el.contains(plus)) { e.preventDefault(); add(plus.dataset.svjAdd); return; }

    var arrow = e.target.closest('[data-svj-scroll]');
    if (arrow && el && el.contains(arrow)) {
      e.preventDefault();
      var track = el.querySelector('#svj-upsell-track');
      if (track) track.scrollBy({ left: parseInt(arrow.dataset.svjScroll, 10) * 220, behavior: 'smooth' });
      return;
    }

    /* header cart icon opens the drawer instead of navigating to /cart */
    var cartLink = e.target.closest('a[href$="/cart"], a[href*="/cart?"], .header__icon--cart, #cart-icon-bubble');
    if (cartLink && (!el || !el.contains(cartLink))) {
      e.preventDefault();
      userClosed = false;
      refresh(true);
    }
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  document.addEventListener('change', function (e) {
    var el = root();
    if (!el || !e.target.classList.contains('svj-qty__input') || !el.contains(e.target)) return;
    var q = parseInt(e.target.value, 10);
    change(parseInt(e.target.dataset.line, 10), isNaN(q) || q < 0 ? 0 : q);
  });

  /* ---- notice cart changes made by the theme's own add-to-cart ---- */
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;

  var nativeFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    var url = input && input.url ? input.url : String(input);
    if (!CART_WRITE.test(url)) return nativeFetch.apply(null, arguments);
    var isAdd = /\/cart\/add/.test(url);
    if (isAdd) openLoading();

    /* JSON add/change requests: ask Shopify to render the drawer in the same response
       (Section Rendering API) so there is no second round trip. FormData bodies are left alone. */
    var bundled = false;
    if (init && typeof init.body === 'string') {
      try {
        var body = JSON.parse(init.body);
        if (!body.sections) {
          body.sections = SECTION;
          body.sections_url = window.location.pathname;
          init = Object.assign({}, init, { body: JSON.stringify(body) });
          bundled = true;
        }
      } catch (e) { /* not JSON */ }
    }

    var result = nativeFetch(input, init);
    result.then(function (res) {
      if (!res.ok) { stopLoading(); return; }
      if (bundled) {
        return res.clone().json().then(function (data) {
          var html = data && data.sections && data.sections[SECTION];
          if (html) render(html, isAdd); else refresh(isAdd);
        });
      }
      refresh(isAdd);
    }).catch(stopLoading);
    return result;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.addEventListener('load', function () {
      if (CART_WRITE.test(String(url))) refresh(/\/cart\/add/.test(String(url)));
    });
    return nativeOpen.apply(this, arguments);
  };
})();
